/*
 * Partition an array into two (pass/fail) based on condition.
 *
 * See: https://stackoverflow.com/questions/11731072/dividing-an-array-by-filter-function
 */
function partition(array, isValid) {
  return array.reduce(
    ([pass, fail], elem) => {
      return isValid(elem) ? [[...pass, elem], fail] : [pass, [...fail, elem]];
    },
    [[], []]
  );
}

/**
 * Taking in all limitations, split them into incusions and exclusions
 * @param  limitations Limitations with key `kind`
 */
export function getInclusionsAndExclusions(limitations: TCoverLimitation[]) {
  return limitations
    ? partition(
        limitations,
        (limitation: TCoverLimitation) => limitation.kind === "INCLUSION"
      )
    : [[], []];
}
